<template>
    <b-modal id="modal-detalhestitulo" size="xl">
         <template v-slot:modal-header="{ close }">
            <h5>Detalhes do Arquivo</h5>
            <b-button size="sm" variant="outline-danger" @click="close()">
                X
            </b-button>
        </template>
        <div class="card" style="margin-bottom: 10px;">
            <div class="card-body">
                <div class="row passEsp">
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Protocolo: </span><span v-html="tituloDetalhe.nm_nr_protocolo" class="detalheProtesto text-uppercase">XXXXXX</span><span v-html="tituloDetalhe.cd_titulo" class="d-none detalheProtesto"></span>
                    </div>
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Data protocolo: </span><span v-html="tituloDetalhe.dt_protocolo_fmt" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-6 px-2'>
                        <span class="font-weight-bold">Praça de Protesto: </span><span v-html="tituloDetalhe.nm_praca_protesto" class="detalheProtesto text-uppercase"></span>
                    </div>
                </div>
                <div class="row passEsp">
                    <div class='col-md-6 px-2'>
                        <span class="font-weight-bold">Chave única: </span><span v-html="tituloDetalhe.nm_chave" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-6 px-2'>
                        <span class="font-weight-bold">Irregularidade: </span><span v-html="tituloDetalhe.cd_irregularidade" class="detalheProtesto text-uppercase"></span>
                    </div>
                </div>
                <div class="row passEsp">
                    <div class='col-md-12 px-2'>
                        <span class="font-weight-bold">Cartório / Comarca: </span><span v-html="tituloDetalhe.crt_descricao" class="detalheProtesto text-uppercase"></span>
                    </div>
                </div>
                <div class="row passEsp">
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Data ocorrência: </span><span v-html="tituloDetalhe.dt_ocorrencia_fmt" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-9 px-2'>
                        <span class="font-weight-bold">Ocorrência: </span><span v-html="tituloDetalhe.nm_ocorrencia" class="detalheProtesto text-uppercase"></span>
                    </div>
                </div>
                <div class="row passEsp">
                    <div class='col-md-12 px-2'>
                        <span class="font-weight-bold">Nome Arquivo: </span><span v-html="tituloDetalhe.nm_arquivo" class="detalheProtesto text-uppercase"></span>
                    </div>
                 </div>
            </div><!-- fecha card-body -->
        </div><!-- fecha card 1-->
        <div class="card" style="margin-bottom: 10px;">
            <div class="card-body">
                <div class="row passEsp">
                    <div class='col-md-9 px-2'>
                        <span class="font-weight-bold">Nome sacador: </span><span v-html="tituloDetalhe.nm_sacador" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-2 px-2'>
                        <span class="font-weight-bold">Documento: </span>
                        <span class="detalheProtesto text-uppercase">
                            {{tituloDetalhe.nm_nr_documento_sacador | documento}}
                        </span>
                    </div>
                    <div class='col-md-1 px-2'>
                        <a class="" v-b-toggle.collapseSacador href="#" @click="false">
                            Ver mais...
                        </a>
                    </div>
                </div>
                <div>
                    <b-collapse id="collapseSacador">
                        <b-card>
                            <div class="row">
                                <div class='col-md-12 px-2'>
                                    <span class="font-weight-bold">Endereço: </span><span v-html="tituloDetalhe.nm_endereco_sacador_cmpl" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                            <div class="row">
                                <div class='col-md-5 px-2'>
                                    <span class="font-weight-bold">Bairro: </span><span v-html="tituloDetalhe.nm_bairro_sacador" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-5 px-2'>
                                    <span class="font-weight-bold">Cidade: </span><span v-html="tituloDetalhe.nm_cidade_sacador" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-2 px-2'>
                                    <span class="font-weight-bold">UF: </span><span v-html="tituloDetalhe.sg_uf_sacador" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>
            </div>
        </div>
        <div class="card" style="margin-bottom: 10px;">
            <div class="card-body">
                <div class="row passEsp">
                    <div class='col-md-9 px-2'>
                        <span class="font-weight-bold">Nome apresentante: </span><span v-html="tituloDetalhe.nm_apresentante" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-2 px-2'>
                        <span class="font-weight-bold">Documento: </span>
                        <span class="detalheProtesto text-uppercase">
                            {{tituloDetalhe.nm_nr_documento_apresentante | documento}}
                        </span>
                    </div>
                    <div class='col-md-1 px-2'>
                        <a class="" v-b-toggle.collapseApresentante href="#" @click="false">
                            Ver mais...
                        </a>
                    </div>
                </div>
                <div>
                   <b-collapse id="collapseApresentante">
                        <b-card>
                            <div class="row">
                                <div class='col-md-12 px-2'>
                                    <span class="font-weight-bold">Endereço: </span><span v-html="tituloDetalhe.nm_endereco_apresentante_cmpl" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                            <div class="row">
                                <div class='col-md-5 px-2'>
                                    <span class="font-weight-bold">Bairro: </span><span v-html="tituloDetalhe.nm_bairro_apresentante" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-5 px-2'>
                                    <span class="font-weight-bold">Cidade: </span><span v-html="tituloDetalhe.nm_cidade_apresentante" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-2 px-2'>
                                    <span class="font-weight-bold">UF: </span><span v-html="tituloDetalhe.sg_uf_apresentante" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>
            </div>
        </div>
        <div class="card" style="margin-bottom: 10px;">
            <div class="card-body">
                <div class="row passEsp">
                    <div class='col-md-9 px-2'>
                        <span class="font-weight-bold">Nome cedente: </span><span v-html="tituloDetalhe.nm_cedente" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-2 px-2'>
                        <span class="font-weight-bold">Documento: </span>
                        <span class="detalheProtesto text-uppercase">
                            {{tituloDetalhe.nm_nr_documento_cedente | documento}}
                        </span>
                    </div>
                    <div class='col-md-1 px-2'>
                        <a class="" v-b-toggle.collapseCedente href="#" @click="false">
                            Ver mais...
                        </a>
                    </div>
                </div>
                <div>
                    <b-collapse id="collapseCedente">
                        <b-card>
                            <div class="row">
                                <div class='col-md-12 px-2'>
                                    <span class="font-weight-bold">Endereço: </span><span v-html="tituloDetalhe.nm_endereco_cedente_cmpl" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                            <div class="row">
                                <div class='col-md-5 px-2'>
                                    <span class="font-weight-bold">Bairro: </span><span v-html="tituloDetalhe.nm_bairro_cedente" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-5 px-2'>
                                    <span class="font-weight-bold">Cidade: </span><span v-html="tituloDetalhe.nm_cidade_cedente" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-2 px-2'>
                                    <span class="font-weight-bold">UF: </span><span v-html="tituloDetalhe.sg_uf_cedente" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>
            </div>
        </div>
        <div class="card" style="margin-bottom: 10px;" v-for="devedor in tituloDetalhe.devedores" v-bind:key="devedor.nm_nr_documento_devedor">
            <div class="card-body">
                <div class="row passEsp">
                    <div class='col-md-9 px-2'>
                        <span class="font-weight-bold">Nome devedor: </span><span v-html="devedor.nm_devedor" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-2 px-2'>
                        <span class="font-weight-bold">Documento: </span><span class="detalheProtesto text-uppercase">{{devedor.nm_nr_documento_devedor | documento}}</span>
                    </div>
                    <div class='col-md-1 px-2'>
                        <a class=""  v-b-toggle.collapseDevedor href="#" @click="false">
                            Ver mais...
                        </a>
                    </div>
                </div>
                <div>
                    <b-collapse id="collapseDevedor">
                        <b-card>
                            <div class="row">
                                <div class='col-md-12 px-2'>
                                    <span class="font-weight-bold">Endereço: </span><span v-html="devedor.nm_endereco_devedor_cmpl" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                            <div class="row">
                                <div class='col-md-5 px-2'>
                                    <span class="font-weight-bold">Bairro: </span><span v-html="devedor.nm_bairro_devedor" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-5 px-2'>
                                    <span class="font-weight-bold">Cidade: </span><span v-html="devedor.nm_cidade_devedor" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-2 px-2'>
                                    <span class="font-weight-bold">UF: </span><span v-html="devedor.sg_uf_devedor" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>
            </div>
        </div>
        <div class="card" style="margin-bottom: 10px;">
            <div class="card-body">
                <div class="row passEsp">
                    <div class='col-md-9 px-2'>
                        <a class="" v-b-toggle.collapseIntimado href="#" @click="false">
                            Intimado
                        </a>
                    </div>
                    <div class='col-md-2 px-2'>
                    </div>
                    <div class='col-md-1 px-2'>
                    </div>
                </div>
                <div>
                    <b-collapse id="collapseIntimado">
                        <b-card>
                            <div class="row">
                                <div class='col-md-2 px-2'>
                                    <span class="font-weight-bold">Edital: </span><span v-html="tituloDetalhe.ic_edital" class="detalheProtesto text-uppercase"></span>
                                </div>
                                <div class='col-md-10 px-2'>
                                    <span class="font-weight-bold">Motivo: </span><span v-html="tituloDetalhe.ds_edital_motivo" class="detalheProtesto text-uppercase"></span>
                                </div>
                            </div>
                        </b-card>
                    </b-collapse>
                </div>
                <div class="row passEsp">
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Nosso número: </span><span v-html="tituloDetalhe.nm_nosso_numero" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Espécie: </span><span v-html="tituloDetalhe.sg_especie" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Número do Titulo: </span><span v-html="tituloDetalhe.nm_nr_titulo" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Moeda: </span>R$
                    </div>
                </div>
                <div class="row passEsp">
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Data de emissão: </span><span v-html="tituloDetalhe.dt_emissao_fmt" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Data de vencimento: </span><span v-html="tituloDetalhe.dt_vencimento_fmt" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Valor do título: </span>
                        <span class="detalheProtesto text-uppercase" v-if="tituloDetalhe.vl_titulo != null "> {{tituloDetalhe.vl_titulo | moeda}} </span>
                    </div>
                    <div class='col-md-3 px-2'>
                        <span class="font-weight-bold">Valor do protesto: </span><span class="detalheProtesto text-uppercase">{{tituloDetalhe.vl_protesto | moeda}}</span>
                    </div>
                </div>
                <div class="row passEsp">
                    <div class='col-md-8 px-2'>
                        <span class="font-weight-bold">Endosso: </span><span v-html="tituloDetalhe.sg_endosso" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-2 px-2'>
                        <span class="font-weight-bold">Tipo: </span> <span v-html="tituloDetalhe.sg_endosso_tipo" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-2 px-2'>
                        <span class="font-weight-bold">Aceito? </span> <span v-html="tituloDetalhe.sg_aceite" class="detalheProtesto text-uppercase"></span>
                    </div>
                </div>
                <div class="row passEsp">
                    <div class='col-md-6 px-2'>
                        <span class="font-weight-bold">Tipo do protesto: </span><span v-html="tituloDetalhe.sg_protesto_tipo" class="detalheProtesto text-uppercase"></span>
                    </div>
                    <div class='col-md-6 px-2'>
                        <span class="font-weight-bold">Motivo: </span> <span v-html="tituloDetalhe.cd_protesto_motivo" class="detalheProtesto text-uppercase"></span>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <b-card>
                <b-tabs content-class="mt-3">
                    <b-tab title="Livro">
                        <div class="container">
                            <div class="row passEsp">
                                <div class='col-md-4 px-2'>
                                    <span class="font-weight-bold">Tipo: </span><span v-html="tituloDetalhe.nm_livro_tipo"></span>
                                </div>
                                <div class='col-md-4 px-2'>
                                    <span class="font-weight-bold">Livro: </span><span v-html="tituloDetalhe.nr_livro"></span>
                                </div>
                                <div class='col-md-4 px-2'>
                                    <span class="font-weight-bold">Folha: </span><span v-html="tituloDetalhe.nr_folha"></span>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Acervo">
                        <div class="row passEsp">
                            <div class='container'>
                                <span class="font-weight-bold">Cartório: </span><span v-html="tituloDetalhe.nr_cartorio_acervo"></span>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Anuência">
                            <div class="container">
                                <div class="row passEsp">
                                    <div class='col-md-4 px-2'>
                                        <span class="font-weight-bold">Apresentante: </span><span v-html="tituloDetalhe.ic_apresentante_pode_dar_anuencia"></span>
                                    </div>
                                    <div class='col-md-4 px-2'>
                                        <span class="font-weight-bold">Sacador: </span><span v-html="tituloDetalhe.ic_sacador_pode_dar_anuencia"></span>
                                    </div>
                                    <div class='col-md-4 px-2'>
                                        <span class="font-weight-bold">Cedente: </span><span v-html="tituloDetalhe.ic_cedente_pode_dar_anuencia"></span>
                                    </div>
                                </div>
                            </div>
                    </b-tab>
                    <b-tab title="Histórico" v-if="tituloDetalhe.historicos != null">
                        <div>
                            <b-table striped hover :items="tituloDetalhe.historicos"></b-table>
                        </div>
                    </b-tab>
                    <b-tab title="Lista de Anuência" v-if="tituloDetalhe.listaAnuencia != null">
                        <div>
                            <b-table striped hover :items="tituloDetalhe.listaAnuencia">
                                <template slot="pdf" slot-scope="row">
                                    <a :id='"dwnldLnk" + row.item.número_anuencia' :download='"aneucnia_" + row.item.número_anuencia' style="display:none;" />
                                    <font-awesome-icon size="1x" icon="download" @click="downloadPdf(row)" style="cursor:pointer;" color="blue"/>
                                </template>
                                <template slot="vlr_cancelamento" slot-scope="row">
                                    {{row.item.vlr_cancelamento | moeda}}
                                </template>
                            </b-table>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
        <b-card class="mt-3" v-if="tituloDetalhe.cd_titulo_ip">
            <div class="text-center">
                <a id='downloadip' :download='"downloadip_" + tituloDetalhe.nm_chave' style="display:none;" />
                <b-button block variant="outline-primary" @click="downloadIP(tituloDetalhe.nm_chave)">Download Instrumento de Protesto</b-button>
            </div>
        </b-card>
    </b-modal>
</template>
<script>
    import API from '../../services/api'

    export default {
        props:{
            tituloDetalhe:{}
        },
        filters: {
            Moeda: function (v){
                if( v == null)return 'R$ 0,00';
                else{
                    v = v.toString().replace(".", ",");
                    v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
                    v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
                    return 'R$ ' + v;
                }
            },
            documento: function (event) {
                var value = event
                if (value == null) {
                    return '';
                } else {
                    let v = value;
                    //Remove tudo o que não é dígito
                    v = v.replace(/\D/g, "");
                    if (v.length < 14) { //CPF
                        //Coloca um ponto entre o terceiro e o quarto dígitos
                        v = v.replace(/(\d{3})(\d)/, "$1.$2");
                        //Coloca um ponto entre o terceiro e o quarto dígitos
                        //de novo (para o segundo bloco de números)
                        v = v.replace(/(\d{3})(\d)/, "$1.$2");
                        //Coloca um hífen entre o terceiro e o quarto dígitos
                        v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                    } else { //CNPJ
                        //Coloca ponto entre o segundo e o terceiro dígitos
                        v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                        //Coloca ponto entre o quinto e o sexto dígitos
                        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                        //Coloca uma barra entre o oitavo e o nono dígitos
                        v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                        //Coloca um hífen depois do bloco de quatro dígitos
                        v = v.replace(/(\d{4})(\d)/, "$1-$2");
                    }
                    return v;
                }
            },
        },
        methods: {
            downloadPdf: function(row){
                let dlnk = document.getElementById('dwnldLnk'+row.item.número_anuencia);
                dlnk.href = 'data:application/pdf;base64,'+row.item.pdf;
                dlnk.click();
            },
            downloadIP(nm_chave)
            {
                const token = localStorage.getItem('jwtToken')
                
                API.post('titulos/downloadIP', {token: token, nm_chave: nm_chave}).then(res => {
                    // let dlnk = document.getElementById('downloadip');
                    // dlnk.href = 'data:application/pdf;base64,'+res.data;
                    // dlnk.click();

                    const base64String = res.data; // your base64 string here
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = 'download_ip.pdf'; // the name of the file to download
                    link.click();
                })

                

            }
        }
    }
</script>
<style scoped>
.passEsp {
        padding-top: 7px !important;
        padding-bottom: 7px !important;
    }
    a
    {
        color:#3490dc;
    }
</style>